import { AiOutlineExclamationCircle } from 'react-icons/ai';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as ArrowForw } from 'assets/images/arrow-forw.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Lotion};
    min-height: calc(100vh - 80px);
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 966px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
`;

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: 20px 25px 20px 16px;
  padding-bottom: 24px;
  border-bottom: 0.5px solid ${ColorPalette.HEX.Platinum2};
  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
  }
`;

interface IHeaderSub {
  ref: any;
  $filters?: boolean;
}
Header.Sub = styled.div<IHeaderSub>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: ${({ $filters }) => ($filters ? '0 16px 16px' : '16px')};
  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
  }
  @media ${({ theme }) => theme.device.desktop} {
    width: calc(100% - 32px);
  }
`;

Header.Title = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  line-height: 1.13em;
  letter-spacing: -1px;
`;
Header.Icon = styled.img``;

export const Cards = styled.div`
  margin-bottom: 110px;

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;

    &.filters {
      margin-top: 0;
    }
  }
  &.list {
    display: flex;
    flex-wrap: wrap;
  }
  &.loading {
    display: flex;
    flex-wrap: wrap;
    max-width: 1000px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const NotFound: any = styled.h5`
  text-align: center;
  margin: auto 30px;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.flightsList.notFound};
`;

NotFound.Icon = styled(AiOutlineExclamationCircle)`
  margin: 0 auto 15px auto;
  font-size: 25px;
  width: 100%;
`;

export const OneWayIcon = styled(ArrowForw)`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 2px;
`;

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: calc(100% - 270px);
    padding: 0 0 0 16px;
  }
`;

export const LeftContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: 270px;
  }
`;
